import { render, staticRenderFns } from "./CurrencyField.vue?vue&type=template&id=57df72ce&"
import script from "./CurrencyField.vue?vue&type=script&lang=ts&"
export * from "./CurrencyField.vue?vue&type=script&lang=ts&"
import style0 from "./CurrencyField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports